import { Component, OnInit, ViewChild } from '@angular/core';
import { DayBookInputsModel } from '../../models/daybook-model';
import { TallyReceiptService } from '../../services/tallyentry-service';
import { Finyearmst } from '../../models/tallyentry-api-model';
import { UtilityService } from '../../services/utility-service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { AccountsLoginService } from '../../services/accounts-login-service';
import { SidenavComponent } from '../sidenav/sidenav.component';

@Component({
  selector: 'app-finyear-master',
  templateUrl: './finyear-master.component.html',
  styleUrls: ['./finyear-master.component.css']
})
export class FinyearMasterComponent implements OnInit {

  public l_formDataDaybook: DayBookInputsModel = new DayBookInputsModel();
  public l_financialYearList = [];
  public dataSource = new MatTableDataSource<Finyearmst>();
  public displayedColumns: string[] = ['finyear', 'status', 'actions'];
  public l_finyearSelectedForActivation: Finyearmst;
  public sessionStorage: Storage = sessionStorage;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;


  constructor(
    private l_TallyReceiptService: TallyReceiptService,
    private l_UtilityService: UtilityService,
    private l_accountsLoginService: AccountsLoginService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.lFN_GetFinancialYear();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  async lFN_GetFinancialYear() {
    let l_finyearResponse = this.l_TallyReceiptService.lFN_GetFinyearmst();
    l_finyearResponse.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          let l_financialYearList: Finyearmst[] = [];
          for await (const l_finyear of JSON.parse(data.body)) {
            l_financialYearList.push(new Finyearmst(l_finyear))
          }
          this.l_financialYearList = l_financialYearList;
          this.dataSource.data = l_financialYearList;
          console.log(this.l_financialYearList);
          this.l_UtilityService.lFN_HideLoader();
          this.l_formDataDaybook.finyearmstId = this.l_financialYearList.find(year => year.status === true)?.finyearmstId;
        }
      },
      error: (l_error) => {
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch Financial Year', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  lFN_ActivateFinancialYear(l_finyearSelected: Finyearmst) {
    console.log('l_finyearSelected ===> ', l_finyearSelected);
    //_ initial checks
    let l_userDetails = JSON.parse(this.sessionStorage.getItem('system_params'));
    console.log('l_userDetails ===> ', l_userDetails);
    if (l_userDetails.isRoleAccountsAdmin === true || l_userDetails.isRoleAccountsSuperadmin === true) {
      this.l_finyearSelectedForActivation = null;
      this.l_finyearSelectedForActivation = l_finyearSelected;
      //_ showDialogConfirmation
      let l_userResponse = this.l_UtilityService.lFN_ShowConfirmationDialog('Confirmation', 
        'Do you really want to activate selected Financial year ?', [ 
          { label: 'Proceed', value: true, color: 'primary' },
          { label: 'Cancel', value: false, color: 'accent' }
        ]);

      l_userResponse.subscribe(async l_userselectValue => {
        console.log('choice ==> ', l_userselectValue);
        if(l_userselectValue === true) {
          await this.lFN_ProceedToActivate();
          await this.lFN_LogoutPostFinyearChange();
        }
      });
        
    } else {
      this.l_UtilityService.lFN_CustomWarningToaster('only system admins and superadmins authorized', 'Unauthorized', 5);
    }

  }

  async lFN_ProceedToActivate() {
    let l_response = this.l_TallyReceiptService.lFN_ActivateFinyearMaster(this.l_finyearSelectedForActivation?.finyearmstId);
    l_response.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          console.log('data success ==> ', data);
          this.l_UtilityService.lFN_HideLoader();
          this.l_UtilityService.lFN_SuccessToaster(data?.body, 'Success');
        }
      },
      error: (l_error) => {
        this.l_UtilityService.lFN_ErrorToaster(l_error, 'Something went wrong');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      }      
    });
  }

  async lFN_LogoutPostFinyearChange() {
    this.l_UtilityService.lFN_ShowLoader();
    let l_response = this.l_accountsLoginService.lFN_logout();
    l_response.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          setTimeout(() => {
            this.sessionStorage.clear();
            this.l_UtilityService.lFN_Navigate('login', 'create');
          }, 500);
          this.l_UtilityService.lFN_HideLoader();
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster('Unable to logout.', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

}
